import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { firebaseEnabled } from './firebase';

const AuthContext = createContext({ user: null });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Dev-only fake auth: always consider user signed in locally
    const isDev = !!(import.meta && import.meta.env && import.meta.env.DEV);
    const fakeEmail = (import.meta && import.meta.env && import.meta.env.VITE_FAKE_AUTH_EMAIL) || 'apopovic.aut@gmail.com';
    if (isDev) {
      const fakeUser = {
        uid: 'dev-apopovic',
        email: String(fakeEmail),
        displayName: 'Alex Popovic',
        photoURL: 'https://www.gravatar.com/avatar/?d=identicon',
        providerId: 'dev-fake',
      };
      setUser(fakeUser);
      setLoading(false);
      return;
    }

    if (!firebaseEnabled) {
      setLoading(false);
      return;
    }
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const logout = () => {
    const isDev = !!(import.meta && import.meta.env && import.meta.env.DEV);
    if (isDev) {
      setUser(null);
      return;
    }
    if (firebaseEnabled) signOut(auth);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, logout }}>
      {children}
    </AuthContext.Provider>
  );
}; 